import { Menu, Typography } from "antd";
import { isModuleApproved } from "../../../routes/ModuleRouter";
import { isSuperAdmin } from "../../../constants/user";
import { featureIsNotAvailable } from "../helper";
import { CustomIcon } from 'datastake-daf/dist/components';
import { useMemo } from "react";
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { matchPath } from "react-router-dom";

export default function SidenavMenu({
  menuMode,
  open,
  selectedKeys,
  filteredItems = [],
  isCollapsed,
  module,
  setHoverItem,
  setTopHover,
  setHoverOpen,
  onMouseMove,
  user,
  goTo,
  notApprovedModal,
  isDemo,
  isDev,
  t = (s) => s,
  checkOnClick = () => { },
  project,
  showSettings = false,
}) {
  const { allItems, dashboardItems, walletItems, settingsItems, moduleItems, analysisItems } = useMemo(() => {
    const allItems = filteredItems.filter((it) =>
      !it.isDashboard && !it.isWallet && !it.isSettings && !it.isModule && !it.isAnalysis);
    const dashboardItems = filteredItems.filter((it) => it.isDashboard);
    const walletItems = filteredItems.filter((it) => it.isWallet);
    const settingsItems = filteredItems.filter((it) => it.isSettings);
    const moduleItems = filteredItems.filter((it) => it.isModule);
    const analysisItems = filteredItems.filter((it) => it.isAnalysis);
    return { allItems, dashboardItems, walletItems, settingsItems, moduleItems, analysisItems };
  }, [filteredItems]);

  const renderSubMenu = (item, i) => ({
    key: i,
    disabled: item.isDisabled,
    onTitleClick: () => {
      // if (item.onTitleClick) {
      //   if (item.onTitleClick === 'PUSH_TO_DD_ANALYSIS') {
      //     goTo(`/app/${module}/analysis/dd`);
      //   }
      // }
    },
    className: "second-level-sub-menu",
    onMouseEnter: e => {
      if (isCollapsed && !item.isDisabled) {
        document.removeEventListener('mousemove', onMouseMove);
        setHoverItem(item);
        setTopHover(e.domEvent.currentTarget.getBoundingClientRect().top)
        setHoverOpen(true);
      }
    },
    onMouseLeave: e => {
      if (isCollapsed) {
        document.addEventListener('mousemove', onMouseMove);
      }
    },
    label: t(item.name),
    children: [
      isCollapsed ? {
        disabled: true,
        icon: <CustomIcon width={15} height={15} name={item.icon} />,
        className: "title",
        key: `${item.path}`,
        label: t(item.name),
      } : null,
      ...item.items.filter(item => item.visible ? item.visible(user, project) : false).map((subitem, j) => ({
        style: subitem.style ? subitem.style : {},
        key: `${subitem.path}-${j}`,
        disabled: item.isDisabled || subitem.isDisabled,
        className: formatClassname([
          typeof selectedKeys[0] === 'string' ? !!(
            selectedKeys[0].includes(subitem.path) || (subitem.subPath || []).find((p) => matchPath(p, selectedKeys[0]))
          ) && 'selected' : '',
        ]),
        onClick: () => {
          checkOnClick({
            event: () => {
              if (isModuleApproved(user, module) || isSuperAdmin(user)) {
                if ((isDemo && !subitem.demo) || (subitem.isDisabled && subitem.isDisabled(user) && !isDev)) {
                  featureIsNotAvailable();
                  return;
                }
                if (subitem.path) {
                  goTo(subitem.path);
                }
              } else {
                notApprovedModal(subitem.path)
              }
            }
          })
        },
        label: t(subitem.name),
      }
      )),
    ].filter((v) => !!v),
  })

  const renderMenu = (items) => (
    <Menu
      theme="dark"
      mode={menuMode}
      inlineCollapsed={open}
      defaultSelectedKeys={selectedKeys}
      selectedKeys={selectedKeys}
      items={items.map((item, i) =>
        item.type === "link" ? (
          isCollapsed ? ({
            onMouseEnter: (e) => {
              if (isCollapsed && !item.isDisabled) {
                document.removeEventListener('mousemove', onMouseMove);
                setHoverItem(item);
                setTopHover(e.domEvent.currentTarget.getBoundingClientRect().top)
                setHoverOpen(true);
              }
            },
            className: formatClassname([
              !!((selectedKeys[0] && item.path) ?
                matchPath(item.path, selectedKeys[0]) : undefined) && 'selected',
            ]),
            disabled: item.isDisabled,
            onMouseLeave: (e) => {
              if (isCollapsed) {
                document.addEventListener('mousemove', onMouseMove);
              }
            },
            key: item.name,
            onTitleClick: () => {
              checkOnClick({
                event: () => {
                  if (isModuleApproved(user, module) || isSuperAdmin(user)) {
                    if ((isDemo && !item.demo) || (item.isDisabled && item.isDisabled(user) && !isDev)) {
                      featureIsNotAvailable();
                      return;
                    }
                    if (item.path) {
                      goTo(item.path)
                    }

                    if (typeof item.onClick === 'function') {
                      item.onClick();
                    }
                  } else {
                    notApprovedModal(item.path)
                  }
                }
              })
            },
            label: t(item.name),
            icon: <CustomIcon width={15} height={15} name={item.icon} />,
            children: [
              {
                key: item.path || item.name,
                style: item.style ? item.style : {},
                icon: <CustomIcon width={15} height={15} name={item.icon} />,
                disabled: item.isDisabled,
                onClick: () => {
                  checkOnClick({
                    event: () => {
                      if (isModuleApproved(user, module) || isSuperAdmin(user)) {
                        if ((isDemo && !item.demo) || (item.isDisabled && item.isDisabled(user) && !isDev)) {
                          featureIsNotAvailable();
                          return;
                        }
                        if (item.path) {
                          goTo(item.path)
                        }

                        if (typeof item.onClick === 'function') {
                          item.onClick();
                        }
                      } else {
                        notApprovedModal(item.path)
                      }
                    }
                  })
                },
                label: t(item.name),
              },
            ]
          }) :
            ({
              key: item.path,
              style: item.style ? item.style : {},
              icon: <CustomIcon width={15} height={15} name={item.icon} />,
              disabled: item.isDisabled,
              onClick: () => {
                checkOnClick({
                  event: () => {
                    if (isModuleApproved(user, module) || isSuperAdmin(user)) {
                      if ((isDemo && !item.demo) || (item.isDisabled && item.isDisabled(user) && !isDev)) {
                        featureIsNotAvailable();
                        return;
                      }
                      if (item.path) {
                        goTo(item.path)
                      }

                      if (typeof item.onClick === 'function') {
                        item.onClick();
                      }
                    } else {
                      notApprovedModal(item.path)
                    }
                  }
                })
              },
              label: t(item.name),
            })
        ) : ({
          key: `item-${i}`,
          icon: <CustomIcon width={15} height={15} name={item.icon} />,
          disabled: item.isDisabled,
          className: formatClassname([
            !!((selectedKeys[0] && Array.isArray(item.items)) ?
              item.items.find((it) => it.items ? it.items.find((item) => {
                return (item.subPath || []).find((p) => matchPath(p, selectedKeys[0]))
              }) :
                (it.subPath || []).find((p) => matchPath(p, selectedKeys[0])) || matchPath(it.path, selectedKeys[0]))
              : undefined) && 'selected'
          ]),
          onTitleClick: () => {
            checkOnClick({
              event: () => {
                // if (item.onTitleClick) {
                //   if (item.onTitleClick === 'PUSH_TO_DD_ANALYSIS') {
                //     goTo(`/app/${module}/analysis/dd`);
                //   }
                // }
              }
            })
          },
          onMouseEnter: e => {
            if (isCollapsed && !item.isDisabled) {
              document.removeEventListener('mousemove', onMouseMove);
              setHoverItem(item);
              setTopHover(e.domEvent.currentTarget.getBoundingClientRect().top)
              setHoverOpen(true);
            }
          },
          onMouseLeave: e => {
            if (isCollapsed) {
              document.addEventListener('mousemove', onMouseMove);
            }
          },
          label: t(item.name),
          children: [
            isCollapsed ? {
              disabled: true,
              icon: <CustomIcon width={15} height={15} name={item.icon} />,
              className: "title",
              label: t(item.name),
              key: `${item.name}-link`,
            } : null,
            ...item.items.filter(item => item.visible ? item.visible(user, project) : false).map((subitem, j) =>
              subitem.items ? renderSubMenu(subitem, `${j}-${subitem.name}`) : (
                {
                  label: <Typography.Text ellipsis={{ tooltip: t(subitem.name) }} style={{ color: module === 'tazama' ? 'var(--base-gray-90)' : 'white' }} className={formatClassname([
                    typeof selectedKeys[0] === 'string' ? !!(
                      selectedKeys[0].includes(subitem.path) || (subitem.subPath || []).find((p) => matchPath(p, selectedKeys[0]))
                    ) && 'selected-label' : '',
                  ])}
                  >
                    {t(subitem.name)}
                  </Typography.Text>,
                  style: subitem.style ? subitem.style : {},
                  key: `${subitem.path}-link-${j}`,
                  disabled: item.isDisabled || subitem.isDisabled,
                  className: formatClassname([
                    typeof selectedKeys[0] === 'string' ? !!(
                      selectedKeys[0].includes(subitem.path) || (subitem.subPath || []).find((p) => matchPath(p, selectedKeys[0]))
                    ) && 'selected-it' : '',
                  ]),
                  onClick: () => {
                    checkOnClick({
                      event: () => {
                        if (isModuleApproved(user, module) || isSuperAdmin(user)) {
                          if ((isDemo && !subitem.demo) || (subitem.isDisabled && subitem.isDisabled(user) && !isDev)) {
                            featureIsNotAvailable();
                            return;
                          }
                          if (subitem.path) {
                            goTo(subitem.path);
                          }
                        } else {
                          notApprovedModal(subitem.path)
                        }
                      }
                    })
                  }
                }
              ))
          ].filter((v) => !!v)
        })
      )}
    />
  );

  return (
    <>
      {dashboardItems.length ? (
        <div className="sidemenu-cont">
          {renderMenu(dashboardItems)}
        </div>
      ) : null}
      {analysisItems.length ? (
        <div className="sidemenu-cont">
          <span className="title-span">
            {t('analysis')}
          </span>
          {renderMenu(analysisItems)}
        </div>
      ) : null}
      {moduleItems.length ? (
        <div className="sidemenu-cont">
          <span className="title-span">
            {t('modules')}
          </span>
          {renderMenu(moduleItems)}
        </div>
      ) : null}
      {allItems.length ? (
        <div className="sidemenu-cont">
          <span className="title-span">
            {t('Data')}
          </span>
          {renderMenu(allItems)}
        </div>
      ) : null}
      {walletItems.length ? (
        <div className="sidemenu-cont">
          <span className="title-span">
            {t('Value')}
          </span>
          {renderMenu(walletItems)}
        </div>
      ) : null}
      {(showSettings && settingsItems.length) ? (
        <div className="sidemenu-cont">
          <span className="title-span">
            {t('Configuration')}
          </span>
          {renderMenu(settingsItems)}
        </div>
      ) : null}
    </>
  )
}
